export default "/images/ac2a6b1dfc43b63ce1e37ddf86f0247b.jpg";